<span class="snackbar">
Otp validated successfully, your menu will be downloaded soon
  <img src="assets/images/popup.png" alt="Cart Popup">
</span>